import React from "react";
import { Link, useOutletContext } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useSeo, type SiteSettings } from "@/lib/publicContent";

type LegalType = "privacy" | "cookie" | "terms";

const META: Record<LegalType, { title: string; field: keyof SiteSettings; testid: string }> = {
  privacy: { title: "Privacy Policy", field: "privacy_policy", testid: "privacy-page" },
  cookie: { title: "Cookie Policy", field: "cookie_policy", testid: "cookie-page" },
  terms: { title: "Termini e Condizioni", field: "terms_conditions", testid: "terms-page" },
};

export default function LegalPage({ type }: { type: LegalType }) {
  const settings = useOutletContext<SiteSettings | null>();
  const meta = META[type];
  const content = (settings?.[meta.field] as string | null) || "";

  useSeo({
    title: `${meta.title} — ${settings?.site_name || "Bonker"}`,
    description: `${meta.title} di ${settings?.site_name || "Bonker"}.`,
  });

  return (
    <div data-testid={meta.testid} className="max-w-3xl mx-auto px-5 md:px-10 py-16 md:py-24">
      <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] font-bold text-muted-foreground hover:text-secondary transition-colors mb-8">
        <ArrowLeft className="h-4 w-4" /> Torna alla home
      </Link>
      <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-8">{meta.title}</h1>

      {content.trim() ? (
        <div className="prose-legal text-sm md:text-base leading-relaxed text-muted-foreground whitespace-pre-wrap" data-testid={`${meta.testid}-content`}>
          {content}
        </div>
      ) : (
        <div className="border border-dashed border-white/15 p-10 text-center" data-testid={`${meta.testid}-empty`}>
          <p className="font-display font-bold text-xl mb-2">Contenuto in aggiornamento</p>
          <p className="text-muted-foreground text-sm">Questo documento sarà presto disponibile.</p>
        </div>
      )}
    </div>
  );
}
